module.exports = __webpack_public_path__ + "static/img/b_1.00b663a1.png";